import{dateToStr as e}from"../../../../utils/DateUtils.mjs";function o(o){return"new"===o.mode?o:{mode:"modify",refValue:e(o.refValue)}}export{o as createRegistrationOptionFromDateToStr};
